'use client';
import React, { useState, useRef, useEffect } from 'react';

const EllipsisText = ({ text }: { text: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  useEffect(() => {
    const measureOverflow = () => {
      const container = containerRef.current;
      if (container && container.scrollWidth > container.clientWidth) {
        setIsOverflowed(true);
      } else {
        setIsOverflowed(false);
      }
    };

    measureOverflow(); // 초기에도 한 번 실행

    // Attach event listener for the case when the parent becomes visible
    window.addEventListener('resize', measureOverflow);

    // Cleanup the event listener
    return () => {
      window.removeEventListener('resize', measureOverflow);
    };
  }, [text, isOverflowed]);

  useEffect(() => {
    // Set timeout to hide the tooltip after 2 seconds
    if (isTooltipVisible) {
      setTimeout(() => {
        setIsTooltipVisible(false);
      }, 1200);
    }
  }, [isTooltipVisible]);

  const handleClick = () => {
    setIsTooltipVisible(!isTooltipVisible);
  };

  return (
    <div
      ref={containerRef}
      onClick={isOverflowed ? handleClick : undefined}
      className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
    >
      {text}
      {isTooltipVisible && (
        <div className="absolute left-10 z-10 w-[30ch] whitespace-normal rounded-md bg-3b-background-contrast p-2 text-3b-text-contrast">
          {text}
        </div>
      )}
    </div>
  );
};

export default EllipsisText;
